export const state = {
  isLoading: false,
  tripRequests: [],
  currentTripRequest: null,
  currentTripLocation: null,
  currentTripTypeId: null,
  currentFundingSources: [],
  selectedTrips: [],
};
